import React from 'react'
import { TimelineEventAttachment } from './TimelineEventAttachment'
import { TimelineEventAttachment as TimelineEventAttachmentType } from '../types/TimelineEventTypes'

interface Props extends React.HTMLAttributes<HTMLUListElement> {
    attachments: TimelineEventAttachmentType[]
}

export const TimelineEventAttachments = ({ attachments, ...props }: Props) => {
    return (
        <ul {...props} className={`${props.className ?? ''} grid gap-1`}>
            {attachments.map((attachment) => (
                <TimelineEventAttachment attachment={attachment}>{attachment.name}</TimelineEventAttachment>
            ))}
        </ul>
    )
}
